var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        size: "small",
                        "label-width": "100px",
                        inline: true,
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { display: "inline-block" },
                          attrs: {
                            label: "机构订单号：",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: { placeholder: "请输入机构订单号" },
                              model: {
                                value: _vm.tableFrom.orderNumber,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.tableFrom,
                                    "orderNumber",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "tableFrom.orderNumber",
                              },
                            },
                            [
                              _c("el-button", {
                                staticClass: "el-button-solt",
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getList(1)
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { display: "inline-block" },
                          attrs: { label: "核销码：", "label-width": "100px" },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: { placeholder: "请输入核销码" },
                              model: {
                                value: _vm.tableFrom.code,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.tableFrom,
                                    "code",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "tableFrom.code",
                              },
                            },
                            [
                              _c("el-button", {
                                staticClass: "el-button-solt",
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getList(1)
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { display: "inline-block" },
                          attrs: { label: "车牌号：", "label-width": "100px" },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: { placeholder: "请输入车牌号" },
                              model: {
                                value: _vm.tableFrom.licensePlate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.tableFrom,
                                    "licensePlate",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "tableFrom.licensePlate",
                              },
                            },
                            [
                              _c("el-button", {
                                staticClass: "el-button-solt",
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getList(1)
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { display: "inline-block" },
                          attrs: {
                            label: "车辆性质：",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: { placeholder: "请输入车辆性质" },
                              model: {
                                value: _vm.tableFrom.vehicleNature,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.tableFrom,
                                    "vehicleNature",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "tableFrom.vehicleNature",
                              },
                            },
                            [
                              _c("el-button", {
                                staticClass: "el-button-solt",
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getList(1)
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { display: "inline-block" },
                          attrs: {
                            label: "供应商订单号：",
                            "label-width": "120px",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: { placeholder: "请输入供应商订单号" },
                              model: {
                                value: _vm.tableFrom.serviceOrderNumber,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.tableFrom,
                                    "serviceOrderNumber",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "tableFrom.serviceOrderNumber",
                              },
                            },
                            [
                              _c("el-button", {
                                staticClass: "el-button-solt",
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getList(1)
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { display: "inline-block" },
                          attrs: { label: "供应商：", "label-width": "100px" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                remote: "",
                                filterable: "",
                                clearable: "",
                                "reserve-keyword": "",
                                placeholder: "请输入供应商关键词",
                                "remote-method": _vm.remoteMethodBySup,
                                loading: _vm.loading,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.getList(1)
                                },
                              },
                              model: {
                                value: _vm.tableFrom.supplierId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tableFrom, "supplierId", $$v)
                                },
                                expression: "tableFrom.supplierId",
                              },
                            },
                            _vm._l(_vm.tableSupplierData, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { display: "inline-block" },
                          attrs: {
                            label: "服务门店：",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.isLoading,
                                  expression: "isLoading",
                                },
                              ],
                              ref: "selectScroll",
                              attrs: {
                                remote: "",
                                filterable: "",
                                clearable: "",
                                "remote-method": _vm.remoteMethod,
                                placeholder: "请选择服务门店",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.getList(1)
                                },
                              },
                              model: {
                                value: _vm.tableFrom.storeId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tableFrom, "storeId", $$v)
                                },
                                expression: "tableFrom.storeId",
                              },
                            },
                            _vm._l(_vm.userOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "城市选择：", prop: "city" } },
                        [
                          _c("el-cascader", {
                            attrs: {
                              clearable: "",
                              props: { checkStrictly: true },
                              options: _vm.merchantCityData,
                            },
                            on: { change: _vm.openDDCityRules },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { display: "inline-block" },
                          attrs: {
                            label: "日期查询：",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "daterange",
                              "value-format": "yyyy-MM-dd",
                              format: "yyyy-MM-dd",
                              placeholder: "选择日期",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                            },
                            on: { change: _vm.onchangeTime },
                            model: {
                              value: _vm.timeVal,
                              callback: function ($$v) {
                                _vm.timeVal = $$v
                              },
                              expression: "timeVal",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "btn_bt" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.exportsTask },
                            },
                            [_vm._v("导出")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.handlerRecord },
                            },
                            [_vm._v("导出详细")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "switchTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "small",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "ID",
                  "min-width": "100",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _vm.merData.typeId === 10 || _vm.merData.typeId === 12
                ? _c("el-table-column", {
                    attrs: {
                      prop: "institution_order_number",
                      label: "机构订单号",
                      "min-width": "100",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "code",
                  label: "核销码",
                  "min-width": "100",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "license_plate",
                  label: "车牌号",
                  "min-width": "100",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "vehicle_nature",
                  label: "车辆性质",
                  "min-width": "100",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _vm._v(" "),
              _vm.merData.typeId === 12
                ? _c("el-table-column", {
                    attrs: {
                      prop: "vehicle_risk_rating_value",
                      label: "车辆风险评分值",
                      "min-width": "120",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.merData.typeId === 10 || _vm.merData.typeId === 12
                ? _c("el-table-column", {
                    attrs: {
                      prop: "order_organization",
                      label: "订单机构",
                      "min-width": "100",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.merData.typeId === 10 || _vm.merData.typeId === 12
                ? _c("el-table-column", {
                    attrs: {
                      prop: "unit_price_of_ai_risk_assessment_agency",
                      label: "AI风险测评机构单价",
                      "min-width": "140",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.merData.typeId === 10 || _vm.merData.typeId === 12
                ? _c("el-table-column", {
                    attrs: {
                      prop: "unit_price_of_customer_research_agency",
                      label: "客户调研机构单价",
                      "min-width": "120",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.merData.typeId === 10 || _vm.merData.typeId === 12
                ? _c("el-table-column", {
                    attrs: {
                      prop: "unit_price_of_safety_testing_institutions",
                      label: "安全检测机构单价",
                      "min-width": "120",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.merData.typeId === 11 || _vm.merData.typeId === 12
                ? _c("el-table-column", {
                    attrs: {
                      prop: "supplier",
                      label: "供应商",
                      "min-width": "100",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "service_store",
                  label: "服务门店",
                  "min-width": "100",
                  "show-overflow-tooltip": true,
                  align: "center",
                },
              }),
              _vm._v(" "),
              _vm.merData.typeId === 11 || _vm.merData.typeId === 12
                ? _c("el-table-column", {
                    attrs: {
                      prop: "vendor_order_number",
                      label: "供应商订单号",
                      "min-width": "100",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.merData.typeId === 11 || _vm.merData.typeId === 12
                ? _c("el-table-column", {
                    attrs: {
                      prop: "unit_price_of_the_ai_risk_assessment_supplier",
                      label: "AI风险测评供应商单价",
                      "min-width": "140",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.merData.typeId === 11 || _vm.merData.typeId === 12
                ? _c("el-table-column", {
                    attrs: {
                      prop: "customer_research_supplier_unit_price",
                      label: "客户调研供应商单价",
                      "min-width": "140",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.merData.typeId === 11 || _vm.merData.typeId === 12
                ? _c("el-table-column", {
                    attrs: {
                      prop: "supplier_service_unit_price",
                      label: "供应商服务单价",
                      "min-width": "120",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.merData.typeId === 11 || _vm.merData.typeId === 12
                ? _c("el-table-column", {
                    attrs: {
                      prop: "overall_service_fee",
                      label: "总体费用",
                      "min-width": "100",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "service_date",
                  label: "服务日期",
                  "min-width": "100",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "180",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("details-order", {
        ref: "qmOrderDetail",
        attrs: { qmOrderInfo: _vm.qmOrderInfo },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visibleFileRecord,
            title: "文件处理履历",
            width: "1200px",
          },
          on: {
            doClose: function ($event) {
              _vm.dialogVisible = false
            },
            "update:visible": function ($event) {
              _vm.visibleFileRecord = $event
            },
          },
        },
        [
          _vm.visibleFileRecord
            ? _c("file-record-list", {
                ref: "fileRecord",
                attrs: { status: _vm.type },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }